import { Typography, TypographyProps } from '@mui/material'
import React from 'react'

type Props = TypographyProps & { children: React.ReactNode }

export const SectionTitle = ({ sx, ...rest }: Props) => {
  return (
    <Typography variant="h6" sx={{ mb: 1, fontWeight: 600, ...sx }} {...rest} />
  )
}

export const SectionSubtitle1 = ({ sx, ...rest }: Props) => {
  return (
    <Typography
      variant="subtitle1"
      sx={{ mb: 1, fontWeight: 600, color: 'text.primary', ...sx }}
      {...rest}
    />
  )
}

export const SectionCaption = ({ sx, ...rest }: Props) => {
  return (
    <Typography
      variant="caption"
      sx={{ display: 'block', mt: 0.5, color: 'text.secondary', ...sx }}
      {...rest}
    />
  )
}
